/* eslint-disable import/order */
import { Slide } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import styles from '../../../resources/theme/global'
import { edit, update } from '../CompaniesActions'
import Form from './Tabs'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

function EditType(props) {
  const { classes } = props
  const dispatch = useDispatch()
  const [company, setCompany] = React.useState(null)

  useEffect(() => {
    const init = async () => {
      const { match } = props
      const resp = await dispatch(edit(match.params.id))
      if (resp?.code === 200) {
        const { data } = resp

        setCompany(data)
      }
    }

    init()
  }, [])

  const onSubmit = values => {
    dispatch(update(values)).then(data => {
      if (data && data.code === 200) {
        props.history.push('/company')
      }
    })
  }

  const onClose = () => {
    props.history.push('/company')
  }

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      fullScreen
      open={company !== null}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" color="inherit" className={classes.flex}>
            Editar Empresa
          </Typography>
          <IconButton color="inherit" onClick={onClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Form data={company} onClose={onClose} onSubmit={onSubmit} />
    </Dialog>
  )
}

export default withStyles(styles)(EditType)
